import type { ReactElement } from 'react'

import { Box, CircularProgress, styled, Typography } from '@mui/material'

const LoadingContainer = styled(Box)({
  textAlign: 'center',
})

interface LoadingProps {
  text?: string
}

export const Loading = ({ text }: LoadingProps): ReactElement => (
  <LoadingContainer>
    <CircularProgress />
    {text && <Typography color="info.main">{text}</Typography>}
  </LoadingContainer>
)
